import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SecurityContext,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { IconComponent } from '../../icon.component';

export interface FaqBlockItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq-block',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './faq-block.component.html',
  styleUrls: ['./faq-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqBlockComponent {
  @Input({ required: true }) title!: string;

  @Input({ required: true })
  set items(value: FaqBlockItem[]) {
    this._items.set(value ?? []);
    this._expanded.set(new Array((value ?? []).length).fill(false));
  }
  get items(): FaqBlockItem[] { return this._items(); }

  private readonly _items = signal<FaqBlockItem[]>([]);
  private readonly _expanded = signal<boolean[]>([]);
  readonly expanded = this._expanded.asReadonly();

  constructor(private readonly sanitizer: DomSanitizer) {}

  toggle(index: number): void {
    const next = [...this._expanded()];
    next[index] = !next[index];
    this._expanded.set(next);
  }

  answerHtml(item: FaqBlockItem): string {
    return (
      this.sanitizer.sanitize(SecurityContext.HTML, item.answer || '') || ''
    );
  }
}
